import styled from 'styled-components';
import { ItemProps } from './interfaces';

const FlexBox = styled.div<ItemProps>`
  flex-grow: ${(props) => props.flexGrow ?? 1};
  flex-shrink: ${(props) => props.flexShrink ?? 1};
  flex-basis: ${(props) => props.flexBasis};
  align-self: ${(props) => props.alignSelf ?? 'auto'};
`;

export default FlexBox;
